import { render } from "./CssCustomization.vue?vue&type=template&id=2b4e7b63"
import script from "./CssCustomization.vue?vue&type=script&lang=js"
export * from "./CssCustomization.vue?vue&type=script&lang=js"

import "./CssCustomization.vue?vue&type=style&index=0&id=2b4e7b63&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__